import React from 'react';
import { logout } from '@kineticdata/react';
import { Avatar, Icon } from '@kineticdata/ui';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import logo from '../../assets/images/kinetic-data-logo.svg';
import { NoticesDropdown } from '../common/NoticesDropdown';

export const Header = () => (
  <nav className="app-header app-header--inverse" role="navigation">
    <a href="/" className="logo">
      <img src={logo} alt="Kinetic Data" />
    </a>
    <div>
      <ul className="nav">
        <li className="nav-text-lg">System Console</li>
      </ul>
    </div>
    <div className="ms-auto">
      <ul className="nav">
        <NoticesDropdown />
        <UncontrolledDropdown nav>
          <DropdownToggle nav tag="button">
            <span>Help</span>
            <Icon name="chevron-down" />
          </DropdownToggle>
          <DropdownMenu end>
            <DropdownItem
              tag="a"
              target="blank"
              href="https://docs.kineticdata.com"
            >
              Platform Documentation
            </DropdownItem>
            {/* Link doesn't currently work */}
            {/*<DropdownItem tag="a" target="blank" href="/app/docs">*/}
            {/*  API Reference Docs*/}
            {/*</DropdownItem>*/}
          </DropdownMenu>
        </UncontrolledDropdown>
        <UncontrolledDropdown nav>
          <Avatar tag={DropdownToggle} className="nav-link" />
          <DropdownMenu end>
            <DropdownItem onClick={logout}>Logout</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </ul>
    </div>
  </nav>
);
